import { createSlice } from "@reduxjs/toolkit";
import {
    fetchReferralEarnTableColumnNames,
    fetchAllReferralEarn,
    createReferralEarn,
    updateReferralEarn,
    deleteReferralEarn,
    activateDeactivateReferralEarn,
    uploadReferralEarnDoc,
    fetchAllReferralStatus,
    updateReferral
} from "./thunk";

const referralEarnSlice = createSlice({
  name: "ReferralEarn",
  initialState: {
    referralEarnData: [],
    referralStatus: [],
    tableColumnNames: [],
    uploadedDocUrl: null,
    docLoad: false, 
    loading: false,
    Headerload: false,
    error: null,
  },
  //  reducers: {
  //   clearUploadedReferralDocUrl: (state) => {
  //     state.uploadedDocUrl = null;
  //   }
  // },
  extraReducers: (builder) => {
    builder

      // Fetch Referral Earn Table Column Names
      .addCase(fetchReferralEarnTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchReferralEarnTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchReferralEarnTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Referral Earn
      .addCase(fetchAllReferralEarn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllReferralEarn.fulfilled, (state, action) => {
        state.loading = false;
        state.referralEarnData = action.payload;
      })
      .addCase(fetchAllReferralEarn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Referral Earn
      .addCase(fetchAllReferralStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllReferralStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.referralStatus = action.payload;
      })
      .addCase(fetchAllReferralStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Referral Earn
      .addCase(updateReferral.pending, (state) => {
        state.error = null;
      })
      .addCase(updateReferral.fulfilled, (state, action) => {
        // Assuming action.payload is the "data" object from your API response:
        // { UpdatedReferral: { ... }, Summary: { ... } }
        const { UpdatedReferral, Summary } = action.payload;

        if (UpdatedReferral && UpdatedReferral.ID) {
          // Ensure ReferredUsersList exists and is an array before mapping
          if (state.referralEarnData && Array.isArray(state.referralEarnData.ReferredUsersList)) {
            state.referralEarnData.ReferredUsersList = state.referralEarnData.ReferredUsersList.map((item) =>
              item.ID === UpdatedReferral.ID ? { ...item, ...UpdatedReferral } : item
            );
          }
        }
        if (Summary) {
          // Ensure referralEarnData and its Summary property can be set
          if (!state.referralEarnData) {
            state.referralEarnData = {}; // Initialize if it's null/undefined
          }
          state.referralEarnData.Summary = Summary;
        }
      })
      .addCase(updateReferral.rejected, (state, action) => {
        state.error = action.payload;
      })

      // // Add Referral Earn
      // .addCase(createReferralEarn.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(createReferralEarn.fulfilled, (state, action) => {
      //   state.referralEarnData = [action.payload.data[0], ...state.referralEarnData];
      // })
      // .addCase(createReferralEarn.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Update Referral Earn
      // .addCase(updateReferralEarn.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(updateReferralEarn.fulfilled, (state, action) => {
      //   const index = state.referralEarnData.findIndex(
      //     (item) => item.ID === action.payload[0].ID
      //   );

      //   if (index !== -1) {
      //     state.referralEarnData[index] = action.payload[0];
      //   }
      // })
      // .addCase(updateReferralEarn.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Delete Referral Earn
      // .addCase(deleteReferralEarn.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(deleteReferralEarn.fulfilled, (state, action) => {
      //   const deletedIds = action.payload.map((item) => item.ID);

      //   // Filter out the deleted items
      //   state.referralEarnData = state.referralEarnData.filter(
      //     (item) => !deletedIds.includes(item.ID)
      //   );
      // })
      // .addCase(deleteReferralEarn.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      // // Active Deactive Referral Earn
      // .addCase(activateDeactivateReferralEarn.pending, (state) => {
      //   state.error = null;
      // })
      // .addCase(activateDeactivateReferralEarn.fulfilled, (state, action) => {
      //   if (action.payload) {
      //     const updatedItem = action.payload[0];
      //     state.referralEarnData = state.referralEarnData.map((item) => item.ID === updatedItem.ID ? {...item, IsActive: updatedItem.IsActive} : item)
      //   }
      // })
      // .addCase(activateDeactivateReferralEarn.rejected, (state, action) => {
      //   state.error = action.payload;
      // })

      //  // Upload Topic Image Icon
      // .addCase(uploadReferralEarnDoc.pending, (state) => {
      //   state.docLoad = true;
      //   state.error = null;
      // })
      // .addCase(uploadReferralEarnDoc.fulfilled, (state, action) => {
      //   state.docLoad = false;
      //   state.uploadedDocUrl = action.payload; 
      // })
      // .addCase(uploadReferralEarnDoc.rejected, (state, action) => {
      //   state.docLoad = false;
      //   state.error = action.payload;
      // })
    },
});

// export const { clearUploadedReferralDocUrl } = referralEarnSlice.actions;
export default referralEarnSlice.reducer;
